import React, { useState, lazy, Suspense } from 'react';
import { Container, Tab, Header, Loader, Segment } from 'semantic-ui-react';

// 懒加载子组件
const SystemLog = lazy(() => import('../Log'));
const QueryLogs = lazy(() => import('../QueryLogs'));

const LoadingFallback = () => (
  <Segment basic style={{ minHeight: 300 }}>
    <Loader active inline="centered">加载中...</Loader>
  </Segment>
);

const LogsUnified = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const panes = [
    {
      menuItem: { key: 'query', icon: 'database', content: 'Query日志' },
      render: () => (
        <Tab.Pane attached={false}>
          <Suspense fallback={<LoadingFallback />}>
            <QueryLogs />
          </Suspense>
        </Tab.Pane>
      ),
    },
    {
      menuItem: { key: 'system', icon: 'book', content: '系统日志' },
      render: () => (
        <Tab.Pane attached={false}>
          <Suspense fallback={<LoadingFallback />}>
            <SystemLog />
          </Suspense>
        </Tab.Pane>
      ),
    },
  ];

  return (
    <Container style={{ marginTop: '2em', marginBottom: '2em' }}>
      <Header as="h1" style={{ marginBottom: '1.5em' }}>
        📋 日志管理
        <Header.Subheader style={{ marginTop: '0.5em' }}>
          查看 LLM Query 日志和系统日志
        </Header.Subheader>
      </Header>

      <Tab 
        panes={panes} 
        activeIndex={activeIndex}
        onTabChange={(e, { activeIndex }) => setActiveIndex(activeIndex)}
        menu={{ secondary: true, pointing: true }}
      />
    </Container>
  );
};

export default LogsUnified;

